import { helper } from '@ember/component/helper';

export function stringify([value]) {
  return String(value);
}

export default helper(stringify);
